/*
 * ZUCCHERO — SMART CART RECOMMENDATIONS (logic)
 * ---------------------------------------------------------------------------------------------------------------
 * Loaded once per page from layout/theme.liquid. The markup lives in snippets/zucchero-cart-recommendations.liquid.
 *
 * WHY THIS IS A SEPARATE ASSET: the cart drawer is re-rendered by the theme through the Section Rendering API,
 * which swaps HTML in with innerHTML. Inline <script> tags inserted that way never execute, so an inline version
 * of this logic ran on some page loads and not on others. An asset in <head> runs every time; it then waits for
 * the block to appear and repaints it whenever the drawer is redrawn.
 *
 * MONEY FORMAT: matches the theme's own output ("$11,650.00 CAD"), not the browser's Intl default ("CA$11,650.00").
 * window.ZQ_MONEY is shared with the product-page section so both surfaces print prices the same way.
 *
 * Config comes from the block's data-* attributes (section settings) and from the JSON tag with the rules
 * (shop metafield custom.reco_rules). Nothing is hardcoded here except Shopify's own cart endpoint fallback.
 */
(function () {
  // Shared money formatter: theme style — symbol, thousands, 2 decimals, currency code after (as the theme does).
  window.ZQ_MONEY = window.ZQ_MONEY || function (cents, currency) {
    currency = currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD';
    var amount = (Number(cents) || 0) / 100;
    var symbols = { CAD: '$', USD: '$', ILS: '₪', JPY: '¥', EUR: '€', GBP: '£' };
    var sym = symbols[currency] || '';
    var digits = currency === 'JPY' ? 0 : 2;
    var num = amount.toLocaleString('en-CA', { minimumFractionDigits: digits, maximumFractionDigits: digits });
    return sym + num + ' ' + currency;
  };

  if (window.__zqCartReco) return;
  window.__zqCartReco = true;

  var cache = { products: [], currency: 'CAD' };
  var justAdded = {};
  var building = false;

  function node() { return document.querySelector('[data-zq-cart-reco]'); }

  function rules() {
    var tag = document.querySelector('[data-zq-reco-rules]');
    try { return tag ? JSON.parse(tag.textContent) : null; } catch (e) { return null; }
  }

  function money(cents, currency) { return window.ZQ_MONEY(cents, currency); }

  function key(title) { return String(title || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }

  // /collections/x/products.json gives decimal-string prices and no product-level "available";
  // /recommendations/products.json gives integer cents and "available". Reconcile both here.
  function normalise(p) {
    if (!p) return null;
    var variants = p.variants || [];
    var live = variants.filter(function (v) { return v.available !== false; });
    var available = typeof p.available === 'boolean' ? p.available : live.length > 0;
    if (!available) return null;
    var raw = typeof p.price !== 'undefined' ? p.price : (live[0] && live[0].price);
    var cents = typeof raw === 'string' ? Math.round(parseFloat(raw) * 100) : (Number(raw) || 0);
    var image = p.featured_image || (p.images && p.images[0]) || '';
    if (image && typeof image === 'object') image = image.src || '';
    return { id: p.id, handle: p.handle, titleKey: key(p.title), title: p.title,
             url: p.url || ('/products/' + p.handle), image: image, cents: cents,
             variantId: live[0] ? live[0].id : null };
  }

  function matchRule(anchor) {
    var R = rules();
    if (!R || !R.rules) return null;
    var type = (anchor.product_type || '').toLowerCase();
    if (!type) return null;
    for (var i = 0; i < R.rules.length; i++) {
      var types = R.rules[i].from_type || [];
      for (var j = 0; j < types.length; j++) {
        if (String(types[j]).toLowerCase() === type) return R.rules[i];
      }
    }
    return null;
  }

  function fromRule(rule, base, exclude) {
    var per = rule.limit || 1;
    var jobs = (rule.show || []).map(function (handle) {
      return fetch(base + '/' + handle + '/products.json?limit=24', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          return ((d && d.products) || []).map(normalise).filter(Boolean)
            .filter(function (p) { return !exclude(p); }).slice(0, per);
        })
        .catch(function () { return []; });
    });
    return Promise.all(jobs).then(function (groups) {
      return groups.reduce(function (acc, g) { return acc.concat(g); }, []);
    });
  }

  function fromShopify(anchorId, intent, limit, url) {
    return fetch(url + '.json?product_id=' + anchorId + '&limit=' + limit + '&intent=' + intent,
                 { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { return ((d && d.products) || []).map(normalise).filter(Boolean); })
      .catch(function () { return []; });
  }

  function card(p, currency, host) {
    var el = document.createElement('div');
    el.className = 'zq-cart-reco__card';
    el.setAttribute('role', 'listitem');
    el.setAttribute('data-zq-id', p.id);
    el.innerHTML =
      '<a class="zq-cart-reco__link" href="' + p.url + '">' +
        (p.image ? '<span class="zq-cart-reco__img"><img src="' + p.image + '" alt="" loading="lazy"></span>' : '') +
        '<span class="zq-cart-reco__name">' + p.title + '</span>' +
        '<span class="zq-cart-reco__price">' + money(p.cents, currency) + '</span>' +
      '</a>';
    if (p.variantId) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'zq-cart-reco__add';
      btn.textContent = host.dataset.addLabel || 'Add';
      btn.addEventListener('click', function () {
        btn.disabled = true;
        justAdded[p.id] = true;
        cache.products = cache.products.filter(function (q) { return q.id !== p.id; });
        el.remove();
        if (host.querySelectorAll('.zq-cart-reco__card').length === 0) host.hidden = true;
        fetch(host.dataset.cartAddUrl || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: p.variantId, quantity: 1 }] })
        }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(build, 350);
        }).catch(function () { build(); });
      });
      el.appendChild(btn);
    }
    return el;
  }

  function paint(host, products, currency) {
    var list = host.querySelector('.zq-cart-reco__list');
    var title = host.querySelector('.zq-cart-reco__title');
    if (!list || !title) return;
    list.innerHTML = '';
    if (products.length === 0) { host.hidden = true; return; }
    title.textContent = host.dataset.title || '';
    title.hidden = !host.dataset.title;
    products.forEach(function (p) { list.appendChild(card(p, currency, host)); });
    host.hidden = false;
  }

  function paintFromCache() {
    var host = node();
    if (!host || cache.products.length === 0) return;
    if (host.querySelector('.zq-cart-reco__card')) return;
    paint(host, cache.products, cache.currency);
  }

  function build() {
    var host = node();
    if (!host || building) return;
    building = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) { cache.products = []; host.hidden = true; building = false; return; }

        var anchor = cart.items.slice().sort(function (a, b) { return b.price - a.price; })[0];
        var limit = parseInt(host.dataset.limit, 10) || 4;

        var ids = {}, handles = {}, titles = {};
        cart.items.forEach(function (i) {
          ids[i.product_id] = true;
          if (i.handle) handles[i.handle] = true;
          titles[key(i.product_title || i.title)] = true;
        });
        var seen = {};
        function exclude(p) {
          if (ids[p.id] || handles[p.handle] || titles[p.titleKey] || justAdded[p.id]) return true;
          return !!(seen[p.id] || seen[p.titleKey]);
        }
        function take(list, out) {
          list.forEach(function (p) {
            if (out.length >= limit || exclude(p)) return;
            seen[p.id] = true; seen[p.titleKey] = true;
            out.push(p);
          });
          return out;
        }

        var rule = matchRule(anchor);
        var out = [];
        return (rule ? fromRule(rule, host.dataset.collectionsUrl, exclude) : Promise.resolve([]))
          .then(function (ruled) {
            take(ruled, out);
            if (out.length >= limit) return out;
            return fromShopify(anchor.product_id, host.dataset.intent, limit + 6, host.dataset.recoUrl)
              .then(function (l) { take(l, out); return out; });
          })
          .then(function () {
            if (out.length >= limit || host.dataset.intent === 'related') return out;
            return fromShopify(anchor.product_id, 'related', limit + 6, host.dataset.recoUrl)
              .then(function (l) { take(l, out); return out; });
          })
          .then(function () {
            cache.products = out;
            cache.currency = cart.currency;
            paint(node() || host, out, cart.currency);
            building = false;
          });
      })
      .catch(function () { building = false; });
  }

  function start() {
    build();
    ['cart:refresh', 'cart:change', 'variant:add'].forEach(function (evt) {
      document.addEventListener(evt, function () { paintFromCache(); setTimeout(build, 350); });
    });
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        paintFromCache();
        var host = node();
        if (host && host.hidden && cache.products.length === 0 && !building) build();
      }, 40);
    }).observe(document.body, { childList: true, subtree: true });

    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0] && (arguments[0].url || arguments[0]);
      var promise = origFetch.apply(this, arguments);
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
        promise.then(function () { setTimeout(build, 350); });
      }
      return promise;
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
